import { basketApiGet } from "./apis/apiCheckout";

export interface BasketItem {
  id: string;
  productId: string;
  quantity: number;

  name: string;
  images: { url: string }[];
  data: { 
    listPrice: number;
    discount: number;
    discountedPrice: number;
    Unit: string;
    currencyCode: string 
  };
}

export interface Charge {
  markupCode: string;
  chargeAmount: number;
  fromAmount: number;
  toAmount: number;
  currency: string;
}
export interface BasketSummary {
  id: string;
  customerNumber: string;
  lines: BasketItem[];
  charges: Charge[];
  subTotal: number;
  netTotal: number;
  totalDiscount: number;
  totalPrice: number;
  currencyCode: string;
  requiresDeliveryChoice: boolean;
}

export const fetchBasketSummary = async (
  customerNumber: string,
  culture: string
): Promise<BasketSummary> => {
  const url = `/api/Basket/customer/${customerNumber}/basketSummary?culture=${culture}`;
  const { data } = await basketApiGet<BasketSummary>(url);
  return data;
};
